import React from 'react';
import { Box, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ACCOUNT_TOP_BAR_PADDING, PROGRAM_TOP_BAR_PADDING } from './topbars-sizes';
import { isInShell } from '../../shell/shell';

const useStyles = makeStyles<Theme, { isAccountLevel: boolean | undefined; inShell: boolean }>(
  ({ spacing }: Theme) => ({
    container: {
      alignItems: 'stretch',
      display: 'flex',
      flex: 1,
      minWidth: 0,
      position: 'relative',
      maxHeight: ({ isAccountLevel, inShell }) =>
        inShell
          ? isAccountLevel
            ? '100vh'
            : `calc(100vh - ${PROGRAM_TOP_BAR_PADDING}px)`
          : `calc(100vh - ${
              isAccountLevel
                ? ACCOUNT_TOP_BAR_PADDING
                : ACCOUNT_TOP_BAR_PADDING + PROGRAM_TOP_BAR_PADDING
            }px)`,
    },
    body: {
      overflow: 'auto',
      borderRadius: '5px',
      boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
      backgroundColor: 'white',
      flex: 1,
      padding: 20,
      maxWidth: '100%',
      minWidth: 0,
      marginLeft: spacing(2),
      marginRight: spacing(2),
      marginBottom: spacing(2),
      marginTop: ({ isAccountLevel }) => (isAccountLevel ? spacing(2) : '0px'),
      // ui-commons detail pane is flex:1 with min-width:auto, so long
      // content (JSON dumps) grows the pane instead of scrolling inside it.
      '& > * > *:last-child': {
        minWidth: 0,
      },
    },
  }),
);

interface Props {
  children: React.ReactNode;
  isAccountLevel?: boolean;
  isInShell?: boolean;
}

export function QlfMasterDetailContainer({ children, isAccountLevel }: Props) {
  const inShell = isInShell();
  const classes = useStyles({ isAccountLevel, inShell });

  return (
    <Box className={classes.container}>
      <div className={classes.body}>{children}</div>
    </Box>
  );
}
